import {Badge} from "react-bootstrap";
import {OrderStatus, PaymentProvider} from "../../api/models";
import {account} from "../../i18n";

const BACKGROUNDS: Record<OrderStatus, string> = {
    pending: 'warning',
    fulfilled: 'success',
    refunded: 'secondary',
    cancelled: 'secondary',
    failed: 'danger'
};

export function OrderStatusBadge({status}: { status: OrderStatus }) {
    const label = account.orders.statuses[status] ?? status;
    const bg = BACKGROUNDS[status] ?? 'secondary';
    return <Badge bg={bg} text={bg === 'warning' ? 'dark' : undefined}>{label}</Badge>;
}

export const providerName = (provider: PaymentProvider) => account.orders.providers[provider] ?? account.orders.providers.stripe;
